var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHeaderRefresh = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.75 7C15.1656 7 15.5 6.66563 15.5 6.25V1.75C15.5 1.33437 15.1656 1 14.75 1C14.3344 1 14 1.33437 14 1.75V4.25313L13.375 3.51875C12.0938 1.98125 10.1594 1 8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C9.575 15 11.0312 14.4781 12.2 13.6C12.5312 13.35 12.5969 12.8813 12.35 12.55C12.1031 12.2188 11.6313 12.1531 11.3 12.4C10.3813 13.0906 9.24063 13.5 8 13.5C4.9625 13.5 2.5 11.0375 2.5 8C2.5 4.9625 4.9625 2.5 8 2.5C9.69687 2.5 11.2156 3.26875 12.225 4.48125L12.2281 4.4875L13.0906 5.5H10.25C9.83438 5.5 9.5 5.83437 9.5 6.25C9.5 6.66563 9.83438 7 10.25 7H14.75Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHeaderRefresh);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "6d8812fd2feff9891f7d2c2d96c45eab.svg";